import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Heading from "../components/heading";
import FeatureCard from "../components/faqcards";
import styled from "@emotion/styled";
import { AllImage } from "../styling/style";
import RoadMapPhone from "../assets/roadmap-phone.png";
import SmallPhone from "../assets/roadmap-phone-small.png";

const BDiv = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (min-width: 700px) and (max-width: 900px) {
    justify-content: center;
  }
`;
const GridContainer = styled(Grid)`
  background: linear-gradient(to top, #fe8d46, #ee5867);
  border-radius: 20px;
  padding: 0px 20px;
  margin: 15% 0% 5%;
  @media (max-width: 600px) {
    padding: 0px;
  }
`;
const PTag = styled(Typography)`
  color: #ffffff;
  font-family: poppins-semibold;
  font-size: 16px;
`;
const Paragrapgh = styled(Typography)`
  color: #ffffff;
  font-family: poppins-regular;
  font-size: 14px;
  max-width: 350px;
`;
const BoxStyle = styled(Box)`
  padding: 20px 30px 0px;
`;
const RoadMapPhoneImg = styled(AllImage)`
  @media (max-width: 600px) {
    display: none;
  }
`;
const RoadMapSmallPhone = styled(AllImage)`
  display: none;
  @media (max-width: 600px) {
    display: block;
  }
`;
const RoadMap = () => {
  return (
    <div>
      <Container maxWidth="lg" id="roadmap">
        <Grid container>
          <Heading title="Roadmap" p="7% 0% 1%" />
          <Grid xs={12} md={4} p={1}>
            <FeatureCard
              p="8px 10px"
              pd="0px 20px"
              mw="350px"
              minh="190px"
              tag="Phase 1: Launch and Foundation"
              data={[
                ["- Development"],
                ["- Launch"],
                ["- Website"],
                ["- Gather user feedback"],
                //   ['- White Paper release'],
                //   ['-Gitbook release']
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} p={1}>
            <FeatureCard
              backbg="linear-gradient( to top, #000000, #EE5867 )"
              mw="350px"
              pd="0px 20px"
              p="8px 10px"
              tag="Phase 2: Feature Expansion"
              data={[
                ["- Feature Updates"],
                ["- Launch a web-based platform"],
                ["- Release advanced analytics tools"],
                ["- Establish partnerships"],
                //  ['- Customization options']
              ]}
            />
          </Grid>
          <Grid xs={12} md={4} p={1}>
            <FeatureCard
              backbg="linear-gradient( to top, #000000, #FE8D46 )"
              p="8px 10px"
              pd="0px 20px"
              minh="60px"
              mw="350px"
              tag="Phase 3: Ongoing Improvements"
              data={[
                ["- Provide updates and optimizations"],
                ["- Continuous expansion of ecosystem features"],
                //  ['- Develop mobile app options'],
                [],
                [],
                [],
                [],
                [],
              ]}
            />
          </Grid>
          <GridContainer container spacing={2}>
            <Grid xs={12} md={6} sx={{ padding: "1% 10px 7%" }}>
              <Heading
                title="Stay Ahead With Instant Token Alerts"
                ta="left"
                p="20px 15px 0px"
                fs="25px"
              />
              <BoxStyle>
                {/* <PTag>Price Alerts</PTag> */}
                <Paragrapgh data-aos="fade-up">
                  Enhance your trading with Peachy Trader's Signal Alert Bot.
                  Set personalized thresholds for volume surges and receive
                  instant notifications. Stay informed about trending tokens
                  with immediate alerts highlighting name, symbol, and the
                  Telegram group. Our Signal Alert Bot operates autonomously,
                  continuously scanning Telegram channels to pinpoint tokens
                  with notable volume spikes. Stay ahead effortlessly with
                  Peachy Trader.
                </Paragrapgh>
              </BoxStyle>
              {/* <BoxStyle>
                <PTag>Order Execution Alerts</PTag>
                <Paragrapgh>
                  Get instant notifications on completed orders.
                </Paragrapgh>
              </BoxStyle>
              <BoxStyle>
                <PTag>Liquidation Alerts</PTag>
                <Paragrapgh>
                  Don't risk losing it all at once. Our timely alerts ensure
                  that users have a window to close their trades before their
                  funds are liquidated!
                </Paragrapgh>
              </BoxStyle> */}
            </Grid>
            <BDiv xs={12} md={6}>
              <RoadMapPhoneImg maxw="486px" src={RoadMapPhone} />
              <RoadMapSmallPhone maxw="476px" src={SmallPhone} />
            </BDiv>
          </GridContainer>
        </Grid>
      </Container>
    </div>
  );
};
export default RoadMap;
